<a href="/view-inicio">
  <button class="btn boton_volver" data-toggle="tooltip" data-placement="top" title="VOLVER" alt="VOLVER"><i
    class="bi bi-chevron-left mr-2"></i>Volver
  </button>
</a>
<h1 class="mt-5 mb-4">Mantenedor de usuarios</h1>
<div *ngIf="usuarioCreado !== ''" class="alert alert-success  tipografía_alertas mt-4 mb-4" role="alert">
  <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>Se ha creado con éxito el usuario {{ usuarioCreado }}.
</div>
<div *ngIf="usuarioEditado !== ''" class="alert alert-success  tipografía_alertas mt-4 mb-4" role="alert">
  <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>{{usuarioEditado}}
</div>
<div class="row justify-content-end mt-5">
  <button title="Agregar usuarios" data-toggle="tooltip" (click)="crearUsuario()" class="boton-primario mt-4 mr-4" style="position: absolute; z-index: 1;"><i class="bi bi-plus-lg mr-2"></i>USUARIO</button>
</div>

<!-- TABLA -->
<div style="margin-top: 20px;">
  <table *ngIf="renderTable" id="tabla-usuarios" [dtOptions]="dtOptions" datatable class="row-border hover table-striped display nowrap table" aria-describedby="tabla usuarios">
    <thead class="header_tabla">
      <tr>
        <th style="width: 50px;">Rol</th>
        <th>Usuario</th>
        <th>Nombre</th>
        <th>Email</th>
        <th>Usuario mod.</th>
        <th>Fecha Mod.</th>
        <th>Vigente</th>
        <th class="text-center" style="width: 70px;">Acción</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let usuario of usuarios; index as i;">
        <td>{{usuario.descRol}}</td>
        <td>{{ usuario.username }}</td>
        <td>{{ usuario.nombre }} {{ usuario.apellidoPaterno }} {{ usuario.apellidoMaterno }}</td>
        <td [title]="usuario.correo">{{ usuario.correo }}</td>
        <td>{{ usuario.usuarioActualizacion == null  ? usuario.usuarioCreacion : usuario.usuarioActualizacion }}</td>
        <td>{{ usuario.fechaActualizacion == null  ? usuario.fechaCreacion : usuario.fechaActualizacion }}</td>
        <td>
          <label class="switch">
            <input type="checkbox" (click)="switchUsuarioVigente(usuario)" [checked]="usuario.estadoUsuario"
            [disabled]="dataUsuario.usuarioId === usuario.usuarioId">
            <span class="slider round" [ngClass]="{'switch-disabled': dataUsuario.usuarioId === usuario.usuarioId}"></span>
          </label>&nbsp; {{ usuario.estadoUsuario ? 'Si' : 'No' }}
        </td>
        <td class="">
          <app-popover [popoverId]="i">
            <ul>

              <li (click)="verDetalle(usuario)" class="list-group-item border-0 py-1"
                title="Ver Detalle">
                <div class="row align-items-center">
                  <div class="col-2 text-center p-0">
                    <i class="bi bi-eye boton-accion_popover px-3"></i>
                  </div>
                  <div class="col-10 p-0 text-left">
                    <p class="mb-0 pl-4">Ver detalle</p>
                  </div>
                </div>
              </li>
              <li (click)="editarUsuario(usuario)" [ngClass]="{'popover-item-disabled': dataUsuario.usuarioId === usuario.usuarioId}" class="list-group-item border-0 py-1" title="Editar">
                <div class="row align-items-center">
                  <div class="col-2 text-center p-0">
                    <i class="bi bi-pencil-square boton-accion_popover px-3"></i>
                  </div>
                  <div class="col-10 p-0 text-left">
                    <p class="mb-0 pl-4">Editar</p>
                  </div>
                </div>
              </li>
              <button hidden id="btn-eliminar" data-toggle="modal" data-target="#modalEliminar"></button>
              <li (click)="validarEliminacionUsuario(usuario)" class="list-group-item border-0 py-1 popover-item-disabled" title="Eliminar" [ngClass]="{'popover-item-disabled': dataUsuario.usuarioId === usuario.usuarioId}">
                <div class="row align-items-center">
                  <div class="col-2 text-center p-0">
                    <i class="bi bi-trash boton-accion_popover px-3"></i>
                  </div>
                  <div class="col-10 p-0 text-left">
                    <p class="mb-0 pl-4">Eliminar</p>
                  </div>
                </div>
              </li>
            </ul>
          </app-popover>
        </td>
      </tr>
    </tbody>
  </table>

  <table *ngIf="!renderTable" [dtOptions]="dtOptions" datatable class="row-border hover table-striped display nowrap table" aria-describedby="tabla usuarios">
    <thead class="header_tabla">
      <tr>
        <th style="width: 50px;">Rol</th>
        <th>Usuario</th>
        <th>Nombre</th>
        <th>Email</th>
        <th>Usuario mod.</th>
        <th>Fecha Mod.</th>
        <th>Vigente</th>
        <th class="text-center" style="width: 70px;">Acción</th>
      </tr>
    </thead>
    <tbody>
    </tbody>
  </table>
</div>

<!-- FIN TABLA -->

<!-- MODAL ELIMINAR -->
<div class="modal fade" id="modalEliminar" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header align-items-center">
                <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Eliminar</h1>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
                    <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="row align-items-center my-3 mx-4">
                        <p class="mb-0 ml-3">¿Estás seguro/a que deseas eliminar el usuario <strong>{{nombreUsuario}}</strong>?</p>
                        <span class="mt-2 ml-3">Al presionar al botón SI, el usuario se eliminará de la configuración.</span>
                    </div>
                </form>
            </div>
            <div class="modal-footer justify-content-center">
                <div class="my-4">
                        <button class="boton-secundario boton_secundario_modal ml-3"
                        title="SI" alt="SI" (click)="eliminarUsuario()" data-dismiss="modal">SI</button>
                    <button class="boton-primario ml-3"
                        title="NO" alt="NO" data-dismiss="modal">NO</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- FIN MODAL ELIMINAR -->